module.exports = __webpack_public_path__ + "static/media/newsletter-april-2023-4.b221a573.jpg";